import React, { PureComponent } from "react";
import Slider from "react-slick";

import { TTP_MEDIA_URL, LAYOUT_DISPOSITIONS } from "Config";
import MediaContainer from "../Media/MediaContainer";
import FetchingMediasList from "../Fetching/FetchingMediasList";
import { slugify } from "Utils";

import _ from "i18n";

export default class MediasListComponent extends PureComponent {
  renderMedias() {
    const { community, fetching, fetched, medias, disposition } = this.props;

    if (fetching) {
      return <FetchingMediasList />;
    }
    //return null;
    if (!fetched || !medias || medias.length === 0) {
      return null;
    }

    let helpBlocTypes = [];
    let counter = 0;
    for (let disp of disposition) {
      if (counter >= medias.length) {
        break;
      }
      counter += LAYOUT_DISPOSITIONS.MEDIA[disp];
      helpBlocTypes.push(disp);
    }

    let blocs = [];

    let i = 0;
    for (const blocType of helpBlocTypes) {
      let nbMedia = LAYOUT_DISPOSITIONS.MEDIA[blocType];
      let blocMedia = [];

      switch (blocType) {
        case "B1":
          for (let j = i; j < Math.min(medias.length, i + nbMedia); j++) {
            blocMedia.push(
              <li
                className="cell smal-12 medium-6 large-3"
                key={`media-container-${medias[j].id}`}
              >
                <MediaContainer media={medias[j]} community={community} />
              </li>
            );
          }
          blocs.push(
            <div className="slick-block" key={Math.random()}>
              <ul className="grid-x">{blocMedia.map(bloc => bloc)}</ul>
            </div>
          );
          break;
      }
      i += nbMedia;
    }

    const settings = {
      dots: true,
      dotsClass: "slick-dots",
      infinite: true,
      arrows: false,
      speed: 500,
      autoplay: false
    };

    return (
      <div className="section-content">
        <Slider {...settings}>{blocs}</Slider>
      </div>
    );

    /*return (
      <div className="section-content">
        <ul className="grid-x">
          {medias.map(media => (
            <li
              className="cell smal-12 medium-6 large-3"
              key={`media-container-${media.id}`}
            >
              <MediaContainer media={media} community={community} />
            </li>
          ))}
        </ul>
      </div>
    );*/
  }

  render() {
    const { community, order, lng } = this.props;

    const { hubPreferences } = community;

    let currentBloc = null;
    let title = _("Gallery");
    let subtitle = _(
      "Images, Videos, PDF, PPT, ... our supports and images at your disposal"
    );

    if (hubPreferences && hubPreferences.layout_settings) {
      currentBloc = hubPreferences.layout_settings.filter(
        bloc => bloc.order === +order
      );
    }
    if (currentBloc && currentBloc.length > 0) {
      if (
        currentBloc[0][`title${lng.toUpperCase()}`] &&
        currentBloc[0][`title${lng.toUpperCase()}`].length > 0
      ) {
        title = currentBloc[0][`title${lng.toUpperCase()}`];
      }
      if (
        currentBloc[0][`subtitle${lng.toUpperCase()}`] &&
        currentBloc[0][`subtitle${lng.toUpperCase()}`].length > 0
      ) {
        subtitle = currentBloc[0][`subtitle${lng.toUpperCase()}`];
      }
    }

    const comUrl = `${TTP_MEDIA_URL}/community/${
      community.url ? community.url : slugify(community.name)
    }/${community.id}`;

    return (
      <section id="new-community-medias">
        <div className="section-body">
          <div className="section-header">
            <div className="section-title">
              <div className="section-title-head">
                <h2>{title}</h2>
                <a href={comUrl} alt="" className="go-app">
                  {_("Media")}
                </a>
              </div>
              <p className="section-title-subhead">{subtitle}</p>
            </div>
            <div className="section-btn">
              <a
                href={
                  comUrl /*TODO Ajout d'une hashtag pour ouvrir la zone d'ajout de media*/
                }
                target="_blanc"
                alt=""
                className="btn-action"
              >
                <span>+</span> {_("Import Medias")}
              </a>
              <a href={comUrl} target="_blanc" alt="" className="btn-see-more">
                {_("See more")}
              </a>
            </div>
          </div>
          {this.renderMedias()}
        </div>
      </section>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/MediasList/MediasListComponent.js